import { render, staticRenderFns } from "./PreviewReport6.vue?vue&type=template&id=6f1d65f8&scoped=true"
import script from "./PreviewReport6.vue?vue&type=script&lang=js"
export * from "./PreviewReport6.vue?vue&type=script&lang=js"
import style0 from "./PreviewReport6.vue?vue&type=style&index=0&id=6f1d65f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1d65f8",
  null
  
)

export default component.exports